export default __webpack_public_path__ + "static/sticker-label-reader-d96747eb8395bccc86174f944e1751ff.svg";